import {
  CHANGE_SELECTED_ADMIN_OBJECT,
  STOP_FETCHING_ADMIN_OBJECT,
} from './types';

const initialState = {
  selectedAdminObject: { value: null },
  isFetching: false,
};

function tlsAccountTags(state = initialState, action) {
  switch (action.type) {
    case CHANGE_SELECTED_ADMIN_OBJECT:
      return {
        ...state,
        selectedAdminObject: action.selectedAdminObject,
        isFetching: true,
      };
    case STOP_FETCHING_ADMIN_OBJECT:
      return {
        ...state,
        isFetching: false,
      };
    default:
      return state;
  }
}

export default tlsAccountTags;
